var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_115_103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 26.9588V10.7438C10.3125 10.3613 10.3125 10.3125 10.7438 10.3125H43.0763C43.5563 10.3125 43.6012 10.3125 43.6012 10.7925V43.125C43.6012 43.605 43.6013 43.605 43.0763 43.605H10.7438C10.3613 43.605 10.3125 43.605 10.3125 43.17V26.9588ZM26.9588 79.6875H10.7438C10.3613 79.6875 10.3125 79.6875 10.3125 79.2525V47.2125C10.3125 46.7325 10.3125 46.7325 10.7925 46.7325H43.1737C43.5562 46.7325 43.605 46.7325 43.605 47.1637V79.3012C43.605 79.6387 43.605 79.6875 43.17 79.6875H26.9588ZM79.6875 26.9588V43.1212C79.6875 43.5562 79.6875 43.5562 79.2525 43.5562H47.1637C46.7812 43.5562 46.6838 43.5563 46.6838 43.125V10.7438C46.6838 10.4063 46.6838 10.3613 47.115 10.3613H78.915C79.6875 10.3613 79.6875 10.3612 79.6875 11.13V26.9588ZM46.8263 63.1875V47.1637C46.8263 46.8262 46.8263 46.7325 47.2125 46.8263H79.5413C79.6388 46.8263 79.5413 47.1637 79.5413 47.3587V79.3012C79.5507 79.3411 79.5498 79.3827 79.5386 79.422C79.5275 79.4614 79.5064 79.4973 79.4775 79.5263C79.4485 79.5552 79.4127 79.5762 79.3733 79.5874C79.3339 79.5985 79.2923 79.5994 79.2525 79.59H47.025C47.025 79.59 46.6875 79.59 46.7363 79.2525V63.1875H46.8263Z",
    fill: "#AAAAAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_115_103",
    x: -4,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_115_103"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_115_103",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.3b3d8351aa9a34c824daeaf0b85bcb78.svg";
export { ForwardRef as ReactComponent };